export const TABLE_WELLBEING_LEADS = 'vuetables_wellbeingLeadsTable'
export const TABLE_WELLBEING_CONTACTS = 'vuetables_wellBeingContactsTable'
export const TABLE_ACTIVITIES_AGENDA_TABLE = 'vuetables_activitiesAgendaTable'
export const TABLE_IFRAME_PROJECT_BUILDER = 'vuetables_iframeProjectsTable'
export const TABLE_IFRAME_PROJECTS_STATISTICS = 'vuetables_iframeProjectsStatisticsTable'
export const TABLE_IFRAME_MEDIA_LIBRARY = 'vuetables_iframeMediaTable'
export const TABLE_IFRAME_LOGO_LIBRARY = 'vuetables_iframeLogoTable'
export const TABLE_IFRAME_BLOCK_INFO = 'vuetables_iframeBlockIntroTable'
export const TABLE_IFRAME_BLOCK_NOISE = 'vuetables_iframeBlockNoiseTable'
export const TABLE_IFRAME_BLOCK_MO_NOISE = 'vuetables_iframeBlockMoNoiseTable'
export const TABLE_IFRAME_BLOCK_THANKS = 'vuetables_iframeBlockThanksTable'
export const TABLE_IFRAME_BLOCK_QUESTIONNAIRE = 'vuetables_iframeBlockQuestionnaireTable'
export const TABLE_IFRAME_BLOCK_ANAMNESE = 'vuetables_iframeBlockAnamneseTable'
export const TABLE_IFRAME_BLOCK_USER_INFO = 'vuetables_iframeBlockUserInfoTable'
export const TABLE_IFRAME_BLOCK_CONTACT = 'vuetables_iframeContactBlockTable'
export const TABLE_IFRAME_BLOCK_TONAL = 'vuetables_iframeTonalBlockTable'
export const TABLE_IFRAME_BLOCK_BIOSIGNALS = 'vuetables_iframeBiosignalsBlockTable'
export const TABLE_IFRAME_BIOSIGNALS_ACCESS_CODES = 'vuetables_iframeBiosignalsAccessCodes'
export const TABLE_LEADS = 'vuetables_leadsTable'
export const TABLE_LEADS_WEB_FLOWS = 'vuetables_leadsWebFlowsTable'
export const TABLE_RANU_RECORDS = 'vuetables_ranuRecordsTable'
export const TABLE_OPTOMETRY_LEADS = 'vuetables_optometryLeadsTable'
export const TABLE_REFERENCES = 'vuetables_referencesTable'
export const TABLE_REPORTS = 'vuetables_reportsTable'
export const TABLE_REPORT_TEMPLATES = 'vuetables_reportTemplatesTable'
export const TABLE_USERS = 'vuetables_usersTable'
export const TABLE_ENTITY_USERS = 'vuetables_entityUsersTable'
export const TABLE_CLINICAL_PEOPLE = 'vuetables_peopleTable'
export const TABLE_CLINICAL_ACCOUNTS = 'vuetables_accountsTable'
export const TABLE_KIOSK_LOCATIONS = 'vuetables_placingsTable'
export const TABLE_ANON_LEADS = 'vuetables_anonLeadsTable'
export const TABLE_CLINICAL_CANCELED_CALL_REQUESTS = 'vuetables_canceledCallRequestsTable'
export const TABLE_CLINICAL_CALL_RATINGS = 'vuetables_callRatingsTable'
export const TABLE_EVOCALL_ACTIVEUSERS = 'vuetables_activeUsersTable'
export const TABLE_HOMELAB_APPOINTMENTS = 'vuetables_homelabAppointmentsTable'
export const TABLE_PEOPLE_MANAGER_APPOINTMENTS = 'vuetables_peopleManagerTable'
export const TABLE_BIOSIGNS_LEADS = 'vuetables_biosignalsLeadsTable'
export const HOMELAB_STATISTICS = 'homelab_statistics_filters'
export const FILTERS_RANU_STATISTICS = 'agenda_ranu_filters'
export const TABLE_EVOCALL_HISTORY = 'vuetables_requestHistoryTable'
export const TABLE_VIRTUAL_WAITING_ROOM_HISTORY = 'vuetables_virtualWaitingRoomRequestHistoryTable'
export const TABLE_CONFIGS_ENTITIES = 'vuetables_entitiesTable'
export const FILTERS_CALENDAR_FACILITIES = 'calendar_facilities'
export const CALENDAR_APPOINTMENTS_FACILITY = 'calendar_appointments_facility'
export const FILTERS_CSM = 'filters_csm'
export const FILTERS_CALENDAR_DAY = 'calendar_day'
export const FILTERS_CALENDAR = 'clinical_calendar_filters'
export const FILTERS_ACTIVITIES_AGENDA_CALENDAR = 'activities_agenda_calendar'
export const FILTERS_LEADS_AGENDA = 'leads_agenda_filters'
export const FILTERS_CALENDAR_VIEW = 'calendar_view'
export const FILTERS_SCREENINGS = 'screenings_filters'
export const FILTERS_KIOSKS = 'kiosk_filters'
export const FILTERS_AGENDA_STATISTICS = 'agenda_statistics_filters'
export const CONTROL_LAST_PAGE = 'last_page'
export const CACHE_ZONE_CODES = 'cached_zone_codes'
export const FILTERS_LEADS_SHOW_TAGS = 'show_tags'
export const AUTH_TOKEN = 'default_auth_token'
export const REFRESH_AUTH_TOKEN = 'default_refresh_auth_token'
export const LAST_PAGE_ACCESSED = 'last_page'
export const SIDEBAR_MINIMIZED = 'sidebar_minimized'
export const APP_VERSION = 'app_version'
export const NEW_VERSION = 'new_version'
export const PERSISTED_KEYS = 'persisted_keys'
export const ACTIVE_REQUEST = 'active_request'
export const WAITING_ROOM_DISPENSER_STATISTICS = 'WAITING_ROOM_DISPENSER_STATISTICS'
export const WAITING_ROOM_AUDIOLOGIST_STATISTICS = 'WAITING_ROOM_AUDIOLOGIST_STATISTICS'
export const CALL_CENTER_STATISTICS = 'call_center_statistics'
export const TABLE_LICENSE_KIOSKS = 'vuetables_kioskLicensesTable'
export const BASIC_STATS = 'basic_stats'
export const FULL_STATS = 'full_stats'
export const HISTORY_STATS = 'history_stats'
export const SANKEY_STATS = 'sankey_stats'
export const PYRAMID_STATS = 'pyramid_stats'
export const FS_STATS = 'fs_stats'
export const PHARMA_STATS = 'pharma_stats'
export const PROMOTER_STATS = 'promoter_stats'
export const FILTERS_LEADS_WEB = 'leads-web-filters'
export const FILTERS_ENTITY_ACTIVITY_USER_TABLE = 'filters_entity_activity_user_table'
export const STATISTICS2_DASHBOARD_HEAR = 'statistics_v2_dashboard_hear'
export const STATISTICS2_MONTHLY_DASHBOARD = 'statistics_v2_monthly_dashboard'
export const STATISTICS2_DASHBOARD_NEW_EVOLLU = 'statistics_v2_dashboard_new_evollu'
export const KPIS_DASHBOARD_NEW_EVOLLU = 'kpis_dashboard_new_evollu'
export const STATISTICS2_OPS_STATS = 'statistics_v2_ops_stats'
export const CHECkUP_PLUS_PATIENTS_TABLE = 'vuetables_checkupPlusPatientsTable'
export const CHECkUP_PLUS_EVALUATIONS_TABLE = 'vuetables_checkupPlusEvaluationsTable'
